import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// withCredentials must be FALSE while the server is configured with a
// wildcard CORS origin (the dev / first-deploy default). Browsers refuse
// credentialed requests when Access-Control-Allow-Origin is "*" and surface
// it as a vague "Network Error". The app uses Bearer tokens via the
// interceptor below, so cookies are not needed for auth today.
export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: false,
});

// Attach bearer token from localStorage as a fallback for cross-domain cookies.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("db_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(", ");
  return JSON.stringify(d);
}
